module.exports = __webpack_public_path__ + "static/media/ALPACA-USDT.ba0c3197.png";